export const LANDING_CONTENT_TYPES = {
    FOOTER: 'LandingFooter',
    MESSAGE: 'LandingMessage',
    MODAL: 'LandingModal'
};